import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function ThrobberDarkIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 64 64"
  }, props, {
    contextType: contextType,
    className: `pi pi-throbber-dark-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M9.481 9.481c-12.437 12.437-12.437 32.601 0 45.038s32.601 12.437 45.038 0c12.437-12.437 12.437-32.601 0-45.038s-32.601-12.437-45.038 0zm40.815 40.815c-10.088 10.088-26.505 10.088-36.593 0s-10.088-26.505 0-36.593 26.505-10.088 36.593 0 10.089 26.505 0 36.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555",
    d: "M13.703 13.703c10.088-10.088 26.505-10.088 36.593 0l4.223-4.222c-12.437-12.437-32.601-12.437-45.038 0l4.222 4.222z"
  })));
}